import axios from 'axios'

const BASE_URL = 'https://www.ucute.space/official-web-server'

const http = axios.create({
	baseURL: BASE_URL
})

// 请求拦截器
http.interceptors.request.use(config => {
	return config
})

// 响应拦截器
http.interceptors.response.use(resp => {
	return resp.data
})

async function get(groupName, resourceNames, key) {
	const res = await http.get('/file_resource/get', { params: { groupName, resourceNames } })
	localStorage.setItem(key, JSON.stringify(res.data))
	return res.data
}

// 作为模块导出
export default {
	get
}
